import { render } from "./SunAndPlanetVisualization.vue?vue&type=template&id=3d4cf095&scoped=true"
import script from "./SunAndPlanetVisualization.vue?vue&type=script&lang=js"
export * from "./SunAndPlanetVisualization.vue?vue&type=script&lang=js"

import "./SunAndPlanetVisualization.vue?vue&type=style&index=0&id=3d4cf095&scoped=true&lang=css"

import exportComponent from "/home/wsl-ubuntu/work-repos/ats-201-build-a-planet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4cf095"]])

export default __exports__